// Constant
export const PAYMENT_TYPE_ENUM = {
    ALL: 0,
    WAITING: 1,
    COD: 2,
    TRANSFER: 3,
    CLAIM: 4
}

// TODO Add label THAI version
export const PAYMENT_WAITING = { id: 1, label: { en: 'WAITING', th: '' } }
export const PAYMENT_COD = { id: 2, label: { en: 'COD', th: '' } }
export const PAYMENT_TRANSFER = { id: 3, label: { en: 'TRANSFER', th: '' } }
export const PAYMENT_CLAIM = { id: 4, label: { en: 'CLAIM', th: '' } }

export const PAYMENT_TYPE_LIST = [
    PAYMENT_WAITING,
    PAYMENT_COD,
    PAYMENT_TRANSFER,
    PAYMENT_CLAIM
]

export const BANK_KBANK = { id: 1 }
export const BANK_SCB = { id: 2 }
export const BANK_BKB = { id: 3 }
export const BANK_KTB = { id: 4 }
export const BANK_TMB = { id: 5 }
export const BANK_KSB = { id: 6 }
export const BANK_GSB = { id: 7 }

export const PAYMENT_BANK_LIST = [
    BANK_KBANK,
    BANK_SCB,
    BANK_BKB,
    BANK_KTB,
    BANK_TMB,
    BANK_KSB,
    BANK_GSB
]

export const CHANNEL_FACEBOOK = { id: 1, label: { en: 'FACEBOOK', th: '' }, mdiIcon: 'mdi-facebook' }
export const CHANNEL_MESSENGER = { id: 2, label: { en: 'MESSENGER', th: '' }, mdiIcon: 'mdi-facebook-messenger' }
export const CHANNEL_LINE = { id: 3, label: { en: 'LINE', th: '' }, mdiIcon: 'fab fa-line' }
export const CHANNEL_CALL = { id: 4, label: { en: 'CALL', th: '' }, mdiIcon: 'mdi-phone' }
export const CHANNEL_INSTAGRAM = { id: 5, label: { en: 'INSTAGRAM', th: '' }, mdiIcon: 'mdi-instagram' }
export const CHANNEL_WWW = { id: 6, label: { en: 'WWW', th: '' }, mdiIcon: 'mdi-web' }
export const CHANNEL_OTHER = { id: 7, label: { en: 'OTHER', th: '' }, mdiIcon: 'mdi-book-open-variant' }

export const PURCHASE_CHANNEL_LIST = [
    CHANNEL_FACEBOOK,
    CHANNEL_MESSENGER,
    CHANNEL_LINE,
    CHANNEL_CALL,
    CHANNEL_INSTAGRAM,
    CHANNEL_WWW,
    CHANNEL_OTHER
]

export const PURCHASE_CHANNEL_MAPPER = {
    call: CHANNEL_CALL,
    facebook: CHANNEL_FACEBOOK,
    instagram: CHANNEL_INSTAGRAM,
    line: CHANNEL_LINE,
    messenger: CHANNEL_MESSENGER,
    other: CHANNEL_OTHER,
    www: CHANNEL_WWW
}

export const ORDER_STATUS_ENUM = {
    ALL: 0,
    PENDING: 1,
    PREPARE_TO_SHIP: 2,
    READY_TO_SHIP: 3,
    SHIPPED: 4,
    OUT_FOR_DELIVERY: 5,
    FAILED_TO_DELIVERY: 6,
    RETURNED: 7,
    DELIVERED: 8,
    COD_REMITED: 9,
    IN_TRANSIT: 10, // SHIPPED + OUT_FOR_DELIVERY + FAILED_TO_DELIVERY
    COMPLETED: 11 // DELETED + DELIVERED + RETURNED + COD_REMITED
    // DELETED: -,
}

export const ORDER_PENDING = { id: 1, label: { en: 'Pending', th: 'รอดำเนินการ' } }
export const ORDER_PREPARE_SHIP = { id: 2, label: { en: 'Prepare to Ship', th: 'เตรียมตัวส่ง' } }
export const ORDER_READY_SHIP = { id: 3, label: { en: 'Ready to Ship', th: 'พร้อมจัดส่ง' } }
export const ORDER_SHIPPED = { id: 4, label: { en: 'Shipped', th: 'ขนส่งรับสินค้าเข้าคลังแล้ว' } }
export const ORDER_DELIVERING = { id: 5, label: { en: 'Out for delivery', th: 'พัสดุกำลังนำส่ง' } }
export const ORDER_DELIVERY_FAIL = { id: 6, label: { en: 'Failed to delivery', th: 'ส่งไม่สำเร็จ' } }
export const ORDER_RETURN = { id: 7, label: { en: 'Return', th: 'ถูกตีกลับ' } }
export const ORDER_DELIVERED = { id: 8, label: { en: 'Delivered', th: 'ส่งสำเร็จแล้ว' } }
export const ORDER_COD_REMITED = { id: 9, label: { en: 'COD Remited', th: 'เงินเข้าระบบแล้ว' } }

export const ORDER_STATUS_LIST = [
    ORDER_PENDING,
    ORDER_PREPARE_SHIP,
    ORDER_READY_SHIP,
    ORDER_SHIPPED,
    ORDER_DELIVERING,
    ORDER_DELIVERY_FAIL,
    ORDER_RETURN,
    ORDER_DELIVERED,
    ORDER_COD_REMITED
]

export const paymentTypeConvertor = [
    { id: 1, th: 'รอชำระเงิน', en: 'waiting', label: 'WAITING' },
    { id: 2, th: 'เก็บเงินปลายทาง', en: 'cod', label: 'COD' },
    { id: 3, th: 'โอนเงิน', en: 'transfer', label: 'TRANSFER' },
    { id: 4, th: 'เคลมสินค้า', en: 'claim', label: 'CLAIM' }
]

export const printKeyword = ['print', 'noprint']

export const COURIER_SCG = { id: 1, logo_path: '', label: 'SCG' }
export const COURIER_KERRY = { id: 2, logo_path: '', label: 'KERRY' }
export const COURIER_DHL = { id: 3, logo_path: '', label: 'DHL' }
export const COURIER_FLASH = { id: 4, logo_path: '', label: 'FLASH' }
export const COURIER_CJ = { id: 5, logo_path: '', label: 'CJ' }
export const COURIER_THAIPOST = { id: 6, logo_path: '', label: 'THAIPOST' }
export const COURIER_DLT = { id: 7, logo_path: '', label: 'DLT' }
export const COURIER_OTHER = { id: 8, logo_path: '', label: 'OTHER' }

export const COURIER_LIST = [
    COURIER_SCG,
    COURIER_KERRY,
    COURIER_DHL,
    COURIER_FLASH,
    COURIER_CJ,
    COURIER_THAIPOST,
    COURIER_DLT,
    COURIER_OTHER
]
